import firedux from '../firedux'
import {dispatch} from '../store'

import {
  EXPERT_SESSION_REQUESTS_ENDPOINT
} from '../../config/constants'

import setSessionRequest from '../actions/set_session_request'

let onSessionRequest = (expertUid, userUid, snapshot) => {
  dispatch(setSessionRequest(snapshot.val(), expertUid, userUid))
}

let boundOnSessionRequest

export const watchImmediateSessionRequest = (expertUid, userUid) => {
  const ENDPOINT = `${EXPERT_SESSION_REQUESTS_ENDPOINT}/${expertUid}/${userUid}`

  let ref = firedux.ref.child(ENDPOINT)

  if (boundOnSessionRequest) unwatchImmediateSessionRequest(expertUid, userUid)

  boundOnSessionRequest = onSessionRequest.bind(null, expertUid, userUid)

  ref.on('value', boundOnSessionRequest)
}

export const unwatchImmediateSessionRequest = (expertUid, userUid) => {
  const ENDPOINT = `${EXPERT_SESSION_REQUESTS_ENDPOINT}/${expertUid}/${userUid}`

  firedux.ref.child(ENDPOINT).off('value', boundOnSessionRequest)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/immediate_session_request.js
 **/